import { useEffect, useContext } from "react"
import { useFormikContext } from "formik"
import { UserContext } from "../../../context/userContext"
import { FormContext } from "../../../context/formContext"

import styles from "../../../styles/Form.module.css"

export default function DocumentRecordStaff({ field, index }) {
  const formik = useFormikContext()
  const userCtx = useContext(UserContext)
  const form = useContext(FormContext)

  useEffect(() => {
    // Register field as loading in FormContext
    form && form.registerLoadingField(field)

    const currentStaff = userCtx.session.user.staff_id
    if (!currentStaff) {
      formik.setFieldValue(field.field_name, "not-set")
    }
    formik.setFieldValue(field.field_name, currentStaff)

    // Notify FormContext that field is loaded
    form && form.completeLoadingField(field)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className={styles.hidden} style={{ order: index }}>
      <input
        type="hidden"
        name={field.field_name}
        value={formik.values[field.field_name]}
      />
    </div>
  )
}
